"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ProviderListItemSchema () {
        return ProviderListItemSchema;
    },
    get ProviderListResponseSchema () {
        return ProviderListResponseSchema;
    }
});
const _zod = require("zod");
const ProviderListItemSchema = _zod.z.object({
    id: _zod.z.string().uuid(),
    displayName: _zod.z.string().nullable()
});
const ProviderListResponseSchema = _zod.z.object({
    items: _zod.z.array(ProviderListItemSchema)
});
